import moment from 'moment'
import { deserializePage, fetchPage } from 'supporticon/api/pages'
import { isJustGiving } from '../../lib/environment'

// Constants
const c = {
  CLEAR: 'app/fundraisingPages/CLEAR',
  FETCH: 'app/fundraisingPages/FETCH',
  FETCH_SUCCESS: 'app/fundraisingPages/FETCH_SUCCESS',
  FETCH_FAILURE: 'app/fundraisingPages/FETCH_FAILURE',
  PERSIST: 'app/fundraisingPages/PERSIST'
}

// Selectors
export * from './selectors'

// Action
export const fetchFundraisingPage = (slug, campaign) => dispatch =>
  Promise.resolve()
    .then(() => dispatch({ type: c.FETCH }))
    .then(() => isJustGiving() ? fetchJGPage(slug) : fetchEDHPage(slug, campaign))
    .then(data => dispatch({ type: c.FETCH_SUCCESS, payload: data }))
    .catch(error => {
      dispatch({ type: c.FETCH_FAILURE })
      return Promise.reject(error)
    })

export const persistPageData = data => ({
  type: c.PERSIST,
  payload: data
})

export const clearPage = () => ({
  type: c.CLEAR
})

const fetchJGPage = (slug) =>
  fetchPage(slug, null, {
    includeFitness: true,
    includeTags: true
  })

const fetchEDHPage = (slug, campaign) => {
  const params = {
    slug,
    campaignSlug: campaign.slug,
    countryCode: campaign.countryCode
  }

  return Promise.resolve()
    .then(() => fetchPage(params))
    .then(page => fetchPage(page.id))
}

// Reducer
const expandedDeserializePage = page => {
  const deserializedPage = deserializePage(page)

  return {
    ...deserializedPage,
    url: `/fundraising/${deserializedPage.slug}`,
    adminUrl: deserializedPage.url,
    formattedCampaignDate: deserializedPage.campaignDate &&
      moment(deserializedPage.campaignDate).format('MMMM Do YYYY'),
    fitnessGoal: isJustGiving()
      ? parseInt(page.pageSummaryWhat)
      : deserializedPage.fitnessGoal
  }
}

export default (state = {}, { type, payload }) => {
  switch (type) {
    case c.CLEAR:
      return {}
    case c.FETCH:
      return { status: 'fetching' }
    case c.FETCH_FAILURE:
      return { status: 'failed' }
    case c.PERSIST:
      return {
        ...state,
        data: {
          ...state.data,
          ...payload
        }
      }
    case c.FETCH_SUCCESS:
      return {
        data: expandedDeserializePage(payload),
        status: 'fetched'
      }
    default:
      return state
  }
}
